<div class="container-file-downloader">
  <button
    class="file-downloader"
    [disabled]="!isEnabled"
    [ngClass]="{
      'file-downloader-button': type === FILE_DOWNLOADER_TYPE_BUTTON,
      'file-downloader-link': type === FILE_DOWNLOADER_TYPE_LINK,
      disabled: !isEnabled,
    }"
    (click)="downloadFile()">
    <img
      alt="icon pdf"
      ngSrc="assets/icons/pdf-icon.svg"
      *ngIf="isEnabled"
      [height]="type === FILE_DOWNLOADER_TYPE_LINK ? '16' : '24'"
      [width]="type === FILE_DOWNLOADER_TYPE_LINK ? '16' : '24'" />
    <img
      alt="icon pdf disabled"
      ngSrc="assets/icons/pdf-icon-disabled.svg"
      *ngIf="!isEnabled"
      [height]="type === FILE_DOWNLOADER_TYPE_LINK ? '16' : '24'"
      [width]="type === FILE_DOWNLOADER_TYPE_LINK ? '16' : '24'" />
    <span
      class="text-body text-left"
      [ngClass]="{
        'text-blue-600': isEnabled,
        'text-neutral-400': !isEnabled,
      }">
      {{ fileName }}.pdf
    </span>
  </button>
  <span class="text-neutral-400 text-body disabled-label" *ngIf="!isEnabled">{{
    disabledLabel
  }}</span>
</div>
